const CHART_VAR_NAMES = ['--chart-1', '--chart-2', '--chart-3', '--chart-4', '--chart-5'] as const;

const readCssVar = (name: string, fallback: string): string => {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};

export const readChartPalette = (): string[] => {
  const fallback = ['#2563eb', '#16a34a', '#d97706', '#dc2626', '#7c3aed'];
  if (typeof document === 'undefined') return fallback;
  return CHART_VAR_NAMES.map((name, index) => readCssVar(name, fallback[index] ?? fallback[0]));
};

export const readChartTheme = () => {
  const isDark = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
  return {
    isDark,
    fg: readCssVar('--foreground', isDark ? '#fafafa' : '#0a0a0a'),
    muted: readCssVar('--muted-foreground', isDark ? '#a1a1aa' : '#71717a'),
    border: readCssVar('--border', isDark ? '#27272a' : '#e4e4e7'),
    card: readCssVar('--card', isDark ? '#09090b' : '#ffffff'),
    palette: readChartPalette(),
  };
};
